import { useQuery } from "@tanstack/react-query";

import { getBankingDetails } from "services";

import { GET_BANKING_DETAILS } from "consts";

// the endpoint reads the signed-in user's farm; farmId keys the cache per farm.
// staleTime 0: the review status also changes on the wallet page and when a new submission cycle starts
export const useGetBankingDetails = ({ farmId }: { farmId?: string }) =>
  useQuery({
    queryKey: [GET_BANKING_DETAILS, farmId],
    queryFn: ({ signal }) => getBankingDetails({ signal }),
    enabled: !!farmId,
    staleTime: 0,
  });
